<template>
  <md-tabs
    :md-active-tab="resultActiveTab"
    @md-changed="resultActiveTab = $event"
  >
    <md-tab id="summary" md-label="統計">
      <!-- 壮大なテーブル -->
      <div class="table-container">
        <table class="">
          <colgroup>
            <col target-col-name="summary_title_1" style="width: 50px;" />
            <col target-col-name="summary_title_2" style="width: 100px;" />
            <col target-col-name="summary_title_3" style="width: 100px;" />
            <col target-col-name="summary_title_4" style="width: 50px;" />
            <col target-col-name="summary_title_5" style="width: 100px;" />
            <col target-col-name="base_customer_count" style="width: 100px;" />
            <col
              target-col-name="compare_customer_count"
              style="width: 100px;"
            />
            <col target-col-name="base_customer_ratio" style="width: 100px;" />
            <col
              target-col-name="compare_customer_ratio"
              style="width: 100px;"
            />
          </colgroup>
          <thead>
            <tr class="row">
              <th colspan="5" class="row-header cell">
                顧客計
              </th>
              <th
                colspan="4"
                class="row-header cell customer-collection-cell border-bottom"
                data-text="顧客計"
                :data-customer-collection="
                  resultData.summary.customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{ resultData.summary.customer_count | formatNumeric('0,0') }}
              </th>
            </tr>
            <tr class="row">
              <th colspan="5" class="row-header cell border-right"></th>
              <th
                colspan="2"
                class="row-header cell border-bottom border-right"
              >
                ID数
              </th>
              <th colspan="2" class="row-header cell border-bottom">
                ID構成比
              </th>
            </tr>
            <tr class="row">
              <th class="row-header cell"></th>
              <th
                colspan="4"
                class="row-header cell border-right border-bottom"
              ></th>
              <th class="row-header cell border-right border-bottom">
                対象
              </th>
              <th class="row-header cell border-right border-bottom">
                比較
              </th>
              <th class="row-header cell border-right border-bottom">
                対象
              </th>
              <th class="row-header cell border-bottom">比較</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell">
                購入顧客計
              </td>
              <td
                class="col-header cell border-right border-bottom"
                colspan="3"
              ></td>
              <td
                v-if="resultData.summary.purchased_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="購入顧客計-対象"
                :data-customer-collection="
                  resultData.summary.purchased_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.purchased_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="resultData.summary.purchased_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="購入顧客計-比較"
                :data-customer-collection="
                  resultData.summary.purchased_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.purchased_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.purchased_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.purchased_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell">
                当期顧客計
              </td>
              <td class="col-header cell border" colspan="2"></td>
              <td
                v-if="resultData.summary.base_term_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="当期顧客計-対象"
                :data-customer-collection="
                  resultData.summary.base_term_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.base_term_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="resultData.summary.base_term_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="当期顧客計-比較"
                :data-customer-collection="
                  resultData.summary.base_term_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.base_term_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.base_term_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.base_term_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell">
                流入計
              </td>
              <td class="col-header cell border"></td>
              <td
                v-if="resultData.summary.in_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流入計-対象"
                :data-customer-collection="
                  resultData.summary.in_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.in_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="resultData.summary.in_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流入計-比較"
                :data-customer-collection="
                  resultData.summary.in_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.in_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td class="cell numeric-cell border">
                {{
                  resultData.summary.in_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.in_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row" v-if="this.isDetail">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border">
                Switch
              </td>
              <td
                v-if="resultData.summary.in_switch_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流入計-Switch-対象"
                :data-customer-collection="
                  resultData.summary.in_switch_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.in_switch_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td
                v-if="resultData.summary.in_switch_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流入計-Switch-比較"
                :data-customer-collection="
                  resultData.summary.in_switch_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.in_switch_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td class="cell numeric-cell border">
                {{
                  resultData.summary.in_switch_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.in_switch_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row" v-if="this.isDetail">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right border-bottom"></td>
              <td class="col-header cell border-right border-bottom"></td>
              <td class="col-header cell border">
                その他から
              </td>
              <td
                v-if="resultData.summary.in_other_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流入計-その他から-対象"
                :data-customer-collection="
                  resultData.summary.in_other_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.in_other_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td
                v-if="resultData.summary.in_other_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流入計-その他から-比較"
                :data-customer-collection="
                  resultData.summary.in_other_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.in_other_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td class="cell numeric-cell border">
                {{
                  resultData.summary.in_other_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.in_other_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right border-bottom"></td>
              <td class="col-header cell border" colspan="2">
                継続計
              </td>
              <td
                v-if="resultData.summary.continued_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="継続計-対象"
                :data-customer-collection="
                  resultData.summary.continued_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.continued_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="resultData.summary.continued_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="継続計-比較"
                :data-customer-collection="
                  resultData.summary.continued_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.continued_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.continued_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.continued_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell">流出計</td>
              <td class="col-header cell border"></td>
              <td
                v-if="resultData.summary.out_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流出計-対象"
                :data-customer-collection="
                  resultData.summary.out_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.out_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">0</td>
              <td
                v-if="resultData.summary.out_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流出計-比較"
                :data-customer-collection="
                  resultData.summary.out_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.out_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.out_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.out_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row" v-if="this.isDetail">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border">
                Switch
              </td>
              <td
                v-if="resultData.summary.out_switch_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流出計-Switch-対象"
                :data-customer-collection="
                  resultData.summary.out_switch_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.out_switch_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="resultData.summary.out_switch_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流出計-Switch-比較"
                :data-customer-collection="
                  resultData.summary.out_switch_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.out_switch_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td class="cell numeric-cell border">
                {{
                  resultData.summary.out_switch_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.out_switch_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row" v-if="this.isDetail">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right border-bottom"></td>
              <td class="col-header cell border">
                その他へ
              </td>
              <td
                v-if="resultData.summary.out_other_base_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流出計-その他へ-対象"
                :data-customer-collection="
                  resultData.summary.out_other_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.out_other_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td
                v-if="resultData.summary.out_other_compare_customer_count > 0"
                class="cell numeric-cell customer-collection-cell border"
                data-text="流出計-その他へ-比較"
                :data-customer-collection="
                  resultData.summary.out_other_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.out_other_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td class="cell numeric-cell border">
                {{
                  resultData.summary.out_other_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.out_other_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right border-bottom"></td>
              <td class="col-header cell border-bottom">
                前期顧客計
              </td>
              <td
                class="col-header cell border-right border-bottom"
                colspan="2"
              ></td>
              <td
                v-if="resultData.summary.compare_term_base_customer_count > 0"
                resultData.summary.compare_term_base_customer_count
                class="cell numeric-cell customer-collection-cell border"
                data-text="前期顧客計-対象"
                :data-customer-collection="
                  resultData.summary.compare_term_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.compare_term_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="
                  resultData.summary.compare_term_compare_customer_count > 0
                "
                resultData.summary.compare_term_compare_customer_count
                class="cell numeric-cell customer-collection-cell border"
                data-text="前期顧客計-比較"
                :data-customer-collection="
                  resultData.summary.compare_term_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.compare_term_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>

              <td class="cell numeric-cell border">
                {{
                  resultData.summary.compare_term_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.compare_term_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
            <tr class="row">
              <td class="col-header cell border-right"></td>
              <td class="col-header cell border-right" colspan="4">
                非購入顧客計
              </td>
              <td
                v-if="resultData.summary.no_purchased_base_customer_count > 0"
                resultData.summary.no_purchased_base_customer_count
                class="cell numeric-cell customer-collection-cell border"
                data-text="非購入顧客計-対象"
                :data-customer-collection="
                  resultData.summary.no_purchased_base_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.no_purchased_base_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td
                v-if="
                  resultData.summary.no_purchased_compare_customer_count > 0
                "
                resultData.summary.no_purchased_compare_customer_count
                class="cell numeric-cell customer-collection-cell border"
                data-text="非購入顧客計-比較"
                :data-customer-collection="
                  resultData.summary.no_purchased_compare_customer_count_filter
                "
                @click="customerClick($event)"
              >
                {{
                  resultData.summary.no_purchased_compare_customer_count
                    | formatNumeric('0,0')
                }}
              </td>
              <td v-else class="cell numeric-cell border">
                0
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.no_purchased_base_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
              <td class="cell numeric-cell border">
                {{
                  resultData.summary.no_purchased_compare_customer_ratio
                    | formatNumeric('0.0%')
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-container">
        <table>
          <colgroup>
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 50px;" />
            <col style="width: 100px;" />
          </colgroup>
          <thead>
            <tr class="row">
              <th colspan="9" class="row-header cell border">
                内訳(定義)
              </th>
            </tr>
            <tr class="row">
              <th colspan="4" class="row-header cell border">
                動態セグメント
              </th>
              <th colspan="4" class="row-header cell border">判定</th>
              <th class="row-header cell border"></th>
            </tr>
            <tr class="row">
              <th colspan="2" class="row-header cell border">前期</th>
              <th colspan="2" class="row-header cell border">当期</th>
              <th colspan="2" class="row-header cell border">流入出</th>
              <th colspan="2" class="row-header cell border">Switch</th>
              <th class="row-header cell border">ID数</th>
            </tr>
            <tr class="row">
              <th class="row-header cell border">対象</th>
              <th class="row-header cell border">比較</th>
              <th class="row-header cell border">対象</th>
              <th class="row-header cell border">比較</th>
              <th class="row-header cell border">対象</th>
              <th class="row-header cell border">比較</th>
              <th class="row-header cell border">対象へ</th>
              <th class="row-header cell border">比較へ</th>
              <th class="row-header cell border"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="row"
              v-for="(model, index) in detailGridModel"
              :key="index"
            >
              <td class="col-header cell detail-cell">{{ model.mark1 }}</td>
              <td class="col-header cell detail-cell">{{ model.mark2 }}</td>
              <td class="col-header cell detail-cell">{{ model.mark3 }}</td>
              <td class="col-header cell detail-cell">{{ model.mark4 }}</td>
              <td class="col-header cell detail-cell">{{ model.text1 }}</td>
              <td class="col-header cell detail-cell">{{ model.text2 }}</td>
              <td
                v-if="
                  resultData.summary[model.rowKey] > 0 &&
                    isSwitch(model.swicth1)
                "
                class="col-header cell detail-cell switch-cell"
                @click="loadSwitchData(index + 1, '対象へ')"
              >
                {{ model.swicth1 }}
              </td>
              <td v-else class="col-header cell detail-cell">
                {{ model.swicth1 }}
              </td>

              <td
                v-if="
                  resultData.summary[model.rowKey] > 0 &&
                    isSwitch(model.swicth2)
                "
                class="col-header cell detail-cell switch-cell"
                @click="loadSwitchData(index + 1, '比較へ')"
              >
                {{ model.swicth2 }}
              </td>
              <td v-else class="col-header cell detail-cell">
                {{ model.swicth2 }}
              </td>

              <td
                v-if="resultData.summary[model.rowKey] > 0"
                class="cell numeric-cell detail-cell"
                :data-text="model.text1 + '-' + model.text2"
                :data-customer-collection="
                  resultData.summary[model.rowKey + '_filter']
                "
                :class="{
                  'customer-collection-cell':
                    resultData.summary[model.rowKey] !== null,
                }"
                @click="customerClick($event)"
              >
                {{ resultData.summary[model.rowKey] | formatNumeric('0,0') }}
              </td>
              <td v-else class="cell numeric-cell detail-cell">0</td>
            </tr>
          </tbody>
        </table>
      </div>
    </md-tab>
    <md-tab
      id="switchList"
      :md-label="this.tabLabel"
      :md-disabled="resultData.switch.length === 0"
    >
      <div class="table-container">
        <table>
          <colgroup>
            <col style="width: 110px;" />
            <col style="width: 400px;" />
            <col style="width: 100px;" />
          </colgroup>
          <thead>
            <tr class="row">
              <th colspan="3" class="row-header cell border">
                {{ switchHeaderText }}
              </th>
            </tr>
            <tr class="row">
              <th class="row-header cell border">
                {{ this.switchColumnModel.headerTextCode }}
              </th>
              <th class="row-header cell border">
                {{ this.switchColumnModel.headerTextName }}
              </th>
              <th class="row-header cell border">
                ID数
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="row"
              v-for="s in resultData.switch"
              :key="s[switchColumnModel.code]"
            >
              <td class="cell border">{{ s[switchColumnModel.code] }}</td>
              <td class="cell border">{{ s[switchColumnModel.name] }}</td>
              <td
                class="cell numeric-cell border customer-collection-cell"
                :data-customer-collection="
                  s[switchColumnModel.customerCountFilter]
                "
                :data-text="s[switchColumnModel.name]"
                @click="customerClick($event)"
              >
                {{ s[switchColumnModel.customerCount] | formatNumeric('0,0') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </md-tab>
  </md-tabs>
</template>

<script>
import repository from '@/repositories/Repository'

export default {
  components: {},
  props: {
    resourceName: {
      type: String,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    tabLabel: {
      type: String,
    },
    /**
     * XX別タブ側の列定義
     */
    switchColumnModel: {
      type: Object,
      default: () => ({
        headerTextCode: undefined,
        headerTextName: undefined,
        code: undefined,
        name: undefined,
        customerCount: undefined,
        customerCountFilter: undefined,
      }),
    },
    /**
     * 分析結果
     */
    resultData: {
      type: Object,
    },
    /**
     * 分析ID
     */
    queryId: {
      type: String,
    },
    /**
     * 自画面のドリルダウンや他画面からの遷移時に渡される引き継ぎID
     *
     * あくまで画面間で分析条件を引き継ぐための識別子で、分析時にサーバーで
     * 発行されるクエリIDとは別なので注意してください。
     *
     * メニューから最初に開く場合など、入力がない場合もあります。
     */
    inherit: {
      type: String,
    },
  },
  data() {
    return {
      /**
       * 結果表示タブ(統計、Switch)
       */
      resultActiveTab: 'summary',
      /**
       * 分析結果
       */
      switchHeaderText: undefined,
      /**
       * 詳細側グリッド定義
       */
      detailGridModel: [
        {
          mark1: '×',
          mark2: '×',
          mark3: '〇',
          mark4: '〇',
          text1: '流入',
          text2: '流入',
          swicth1: '',
          swicth2: '',
          rowKey: 'in_in_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '〇',
          mark4: '〇',
          text1: '流入',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'in_continued_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '〇',
          mark4: '×',
          text1: '流入',
          text2: '流出',
          swicth1: '〇',
          swicth2: '',
          rowKey: 'in_out_customer_count',
        },
        {
          mark1: '×',
          mark2: '×',
          mark3: '〇',
          mark4: '×',
          text1: '流入',
          text2: '非購入',
          swicth1: '',
          swicth2: '',
          rowKey: 'in_no_purchasedcustomer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '〇',
          mark4: '〇',
          text1: '継続',
          text2: '流入',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_in_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '〇',
          mark4: '〇',
          text1: '継続',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_continued_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '〇',
          mark4: '×',
          text1: '継続',
          text2: '流出',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_out_customer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '〇',
          mark4: '×',
          text1: '継続',
          text2: '非購入',
          swicth1: '',
          swicth2: '',
          rowKey: 'continued_no_purchasedcustomer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '×',
          mark4: '〇',
          text1: '流出',
          text2: '流入',
          swicth1: '',
          swicth2: '〇',
          rowKey: 'out_in_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '×',
          mark4: '〇',
          text1: '流出',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'out_continued_customer_count',
        },
        {
          mark1: '〇',
          mark2: '〇',
          mark3: '×',
          mark4: '×',
          text1: '流出',
          text2: '流出',
          swicth1: '',
          swicth2: '',
          rowKey: 'out_out_customer_count',
        },
        {
          mark1: '〇',
          mark2: '×',
          mark3: '×',
          mark4: '×',
          text1: '流出',
          text2: '非購入',
          swicth1: '',
          swicth2: '',
          rowKey: 'out_no_purchasedcustomer_count',
        },
        {
          mark1: '×',
          mark2: '×',
          mark3: '×',
          mark4: '〇',
          text1: '非購入',
          text2: '流入',
          swicth1: '',
          swicth2: '',
          rowKey: 'no_purchased_in_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '×',
          mark4: '〇',
          text1: '非購入',
          text2: '継続',
          swicth1: '',
          swicth2: '',
          rowKey: 'no_purchased_continued_customer_count',
        },
        {
          mark1: '×',
          mark2: '〇',
          mark3: '×',
          mark4: '×',
          text1: '非購入',
          text2: '流出',
          swicth1: '',
          swicth2: '',
          rowKey: 'no_purchased_out_customer_count',
        },
      ],
    }
  },
  methods: {
    customerClick(e) {
      const text = e.currentTarget.getAttribute('data-text')
      const id = e.currentTarget.getAttribute('data-customer-collection')
      const customer = { id, text }
      this.$emit('echo-toggle-customer-collection', customer)
    },
    async getQueryResultRowsData(path) {
      const url = await this.$longQuery.getQueryResultFetchUrl(
        this.resourceName,
        this.queryId,
        path,
      )
      if (url) {
        const fetch = await repository.giggle.get(url).then(r => r.data)
        if (fetch) {
          return fetch.rows
        }
      }
    },
    /**
     * 統計側データを取得して表示
     */
    async loadSummaryData() {
      const rows = await this.getQueryResultRowsData('summary')
      if (rows) {
        this.$emit('update:resultData', {
          summary: rows[0],
          switch: this.resultData.switch,
        })
      }
      if (!this.$store.state.isQueryFullFeatured) {
        document.documentElement.style.setProperty('--link-color', '#999')
      } else {
        document.documentElement.style.setProperty('--link-color', '#448aff')
      }
    },
    /**
     * Switch明細側データを取得して表示
     */
    async loadSwitchData(state, headerText) {
      this.switchHeaderText = headerText
      const rows = await this.getQueryResultRowsData('switch/' + state)
      if (rows) {
        this.$emit('update:resultData', {
          summary: this.resultData.summary,
          switch: rows,
        })
        this.resultActiveTab = 'switchList'
      }
    },
    /**
     * Switch行か判定
     */
    isSwitch(char) {
      return char === '〇'
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  border: 1px solid #ccc;
  border-spacing: 0;
  letter-spacing: 0.01em;
  table-layout: fixed;
  width: 0;
  border-collapse: collapse;
}
.table-container {
  box-sizing: border-box;
  overflow: scroll;
  height: 100%;
  width: 1024px;
}
.cell {
  font-size: 13px;
  font-weight: 400;
  padding: 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row {
  height: 24px;
  line-height: 23px;
}
.border-bottom {
  background-color: #f3f3f3;
  border-bottom: 1px solid #ccc;
}
.border-right {
  background-color: #f3f3f3;
  border-right: 1px solid #ccc;
}
.border {
  background-color: transparent;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.row-header {
  background-color: #f3f3f3;
}
.col-header {
  background-color: #f3f3f3;
}
.detail-cell {
  text-align: center;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.numeric-cell {
  text-align: right;
}
.customer-collection-cell {
  cursor: pointer;
  color: var(--link-color, #448aff);
  text-decoration: underline;
}
.customer-collection-selected {
  color: inherit;
  background: #bdbdbd !important;
  text-decoration: none;
}
.switch-cell {
  cursor: pointer;
  color: var(--md-theme-default-primary-on-background, #448aff);
  text-decoration: underline;
}
</style>
